import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useStyles } from './PagePreview.style';
import getPageById from './getPage';
import { useParams } from 'react-router-dom'

export default function PagePreview() {
  const classes = useStyles();
  const [page, setPage] = useState(null);
  const { id } = useParams()

  useEffect(() => {
    if(!id) return;
    
    const fetchPage = async () => {
      try {
        const res = await getPageById(id);
        setPage(res);
      } catch (error) {
        console.log(error);
      }
    };

    fetchPage();
  }, [id]);

  return (
    <Grid className={classes.container}>
      <Grid item xs={12} className={classes.mainGrid}>
        {page ?
          <div dangerouslySetInnerHTML={{__html: page.content}}></div>
        : 
          <div>Loading...</div>
        }
      </Grid>
    </Grid>
  );
}